import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const DISMISSED_KEY = 'phone-numbers-notice-dismissed';

const wasDismissed = () => {
  try {
    return localStorage.getItem(DISMISSED_KEY) === '1';
  } catch {
    // Private windows and blocked storage: show it; dismissing then lasts the visit.
    return false;
  }
};

/**
 * Tells admins, once, what changed when their company got several numbers
 * per person: adding a number no longer turns texts on. Dismissed per
 * browser, which is all it needs: it is a heads-up, not a record.
 */
export function PhoneNumbersNotice() {
  const { t } = useTranslation(['common']);
  const [dismissed, setDismissed] = useState(wasDismissed);
  if (dismissed) return null;

  return (
    <div role="note" className="mb-4 flex items-start gap-3 rounded-md bg-blue-50 p-4 text-base text-blue-900">
      <div className="flex-1">
        <p className="font-semibold">{t('Employees can now have several phone numbers')}</p>
        <p className="mt-1">
          {t(
            "Each employee chooses which of their numbers get texts and confirms each one with a code. A number you add or import gets no texts until they do; we email them a link. Numbers that already got texts keep getting them."
          )}
        </p>
      </div>
      <button
        type="button"
        onClick={() => {
          try {
            localStorage.setItem(DISMISSED_KEY, '1');
          } catch {
            // As above: dismissed for this visit only.
          }
          setDismissed(true);
        }}
        className="rounded-md px-2 py-1 font-semibold text-blue-900 hover:bg-blue-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-700 min-h-[44px] min-w-[44px]"
      >
        {t('Got it')}
      </button>
    </div>
  );
}

export default PhoneNumbersNotice;
